import RootStore from '../../store/RootStore';
import { style } from '../../utils/image';

const commentSize = [16, 18, 25, 36, 45];
const commentColor = [0xffffff, 0x0000ff, 0xcc0000, 0xff66ff, 0xffff33];

const PluginDanmuku = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(rootStore: RootStore) {
        this.useDanmuku = true;
        this.status = true;
        this.manager = null;
        this.store = rootStore;

        this.bindMessage = this.onMessage.bind(this);
      },
      createEl: function(el: any) {
        this.video = el;

        if (this.useDanmuku) {
          this.iconDom = document.createElement('div');
          this.iconDom.className = 'prism-danmuku';
          this.iconDom.addEventListener('click', () => {
            this.setDanmuku(!this.status);
          });

          this.danmukuContainer = document.createElement('div');
          this.danmukuContainer.className = 'player-danmuku';
          let cmDom = document.createElement('div');
          cmDom.className = 'player-danmuku-container';
          this.danmukuContainer.appendChild(cmDom);

          if (el) {
            let controlBar = el.querySelector('.prism-controlbar');
            controlBar.appendChild(this.iconDom);

            el.appendChild(this.danmukuContainer);
          }

          this.manager = new window.CommentManager(
            this.danmukuContainer.querySelector('.player-danmuku-container')
          );
          this.manager.init('css');

          /* 根据视频播放器的 timeupdate 事件更新弹幕的事件轴   */
          el.querySelector('video').ontimeupdate = () => {
            if (el.querySelector('video') !== null) {
              this.manager.time(el.querySelector('video').currentTime * 1000);
            }
          };

          this.setDanmuku(this.status);
        }
      },
      setDanmuku: function(open: boolean) {
        if (this.useDanmuku) {
          this.status = open;

          if (this.status) {
            this.danmukuStart();
          } else {
            this.danmukuStop();
          }
        }
      },
      danmukuStart: function() {
        this.iconDom.innerHTML = `<img src="//image1${window.__basename}/npm/video/img/icon_danmuku_open.png" />`;
        this.manager.start();
        // this.manager.load(danmukuList);

        this.store.imStore!.addMessageListener('text', this.bindMessage);
        // this.store.imStore!.addMessageListener('emotion', this.bindMessage);
        // this.store.imStore!.addMessageListener('gift', this.bindMessage);
        this.store.imStore!.addMessageListener('question', this.bindMessage);
      },
      danmukuStop: function() {
        this.iconDom.innerHTML = `<img src="//image1${window.__basename}/npm/video/img/icon_danmuku_close.png" />`;
        this.manager.stop();
        this.manager.clear();

        this.store.imStore!.removeMessageListener('text', this.bindMessage);
        // this.store.imStore!.removeMessageListener('emotion', this.bindMessage);
        // this.store.imStore!.removeMessageListener('gift', this.bindMessage);
        this.store.imStore!.removeMessageListener('question', this.bindMessage);
      },
      randomIndex: function(max: number) {
        return Math.floor(Math.random() * max);
      },
      insert: function(comment: any) {
        if (comment) {
          this.manager.send({
            // stime: this.video.currentTime + 1,
            size: commentSize[this.randomIndex(5)],
            color: commentColor[this.randomIndex(5)],
            ...comment
          });
        }
      },
      onMessage: function(e: any) {
        if (e) {
          let { type, content } = e;
          if (type && content) {
            let comment = {} as any;
            if (['text', 'question'].indexOf(type) > -1) {
              comment.mode = 1;
              comment.text = content;
            }
            // if(['emotion', 'gift'].indexOf(type) > -1) {
            //   comment.mode = 17;
            //   if(type == 'emotion') {
            //     try {
            //       let data = JSON.parse(content);
            //       comment.code = `<img src="${style(data.image, 'avatar_150')}" style="width:28px" />`;
            //     }catch(e) {
            //
            //     }
            //   }
            //   if(type == 'gift') {
            //     try {
            //       let data = JSON.parse(content);
            //       comment.code = `<img src="${style(data.images, 'avatar_150')}" style="width:28px" />`;
            //     }catch(e) {
            //
            //     }
            //   }
            // }

            if (comment.text || comment.code) {
              console.log(comment);
              if (comment.text && comment.text.length > 20) {
                comment.dur = Math.max(
                  5000,
                  comment.text && comment.text.length
                    ? Math.round((comment.text.length * 1000) / 5)
                    : 0
                );
              } else {
                comment.dur = 5000;
              }
              this.insert(comment);
            }
          }
        }
      }
    })
  : null;

export default PluginDanmuku;
